import React, { useState } from "react";

import andres from "../img/4.jpg";
import aldo from "../img/1.jpg";
import diego from "../img/5.jpg";
import pamela from "../img/2.jpg";
import Katherina from "../img/3.jpg";

import logo from "../img/logos/escudo.png";

import "../css/EquipoDirectivo.css";

function QuienesSomos() {

  const equipo = [
    {
      numero: "01",
      nombre: "Andrés Tapia Torres",
      cargo: "Director(a)",
      imagen: andres,
    },
    {
      numero: "02",
      nombre: "Aldo Alberto Bustamante",
      cargo: "Inspector General",
      imagen: aldo,
    },
    {
      numero: "03",
      nombre: "Diego Pozo Cabello",
      cargo: "U.T.P.",
      imagen: diego,
    },
    {
      numero: "04",
      nombre: "Pamela Contreras Pérez",
      cargo: "Convivencia Escolar",
      imagen: pamela,
    },
    {
      numero: "05",
      nombre: "Katherina Paz Cifuentes",
      cargo: "Coordinadora P.I.E.",
      imagen: Katherina,
    },
  ];

  const [imagenGrande, setImagenGrande] = useState(null);

  return (

    <section
      id="QuienesSomos"
      className="esc-directivo-container"
    >

      <div className="esc-directivo-wrapper">

        {/* Fondo Decorativo */}

        <div className="esc-directivo-bg-left"></div>
        <div className="esc-directivo-bg-right"></div>

        {/* Logo */}

        <div className="esc-directivo-logo">

          <img
            src={logo}
            alt="Escudo Escuela Nueva Zelandia"
          />

        </div>

        {/* Título */}

        <div className="esc-directivo-header">

          <h1 className="esc-directivo-title">

            Equipo Directivo <span>2026</span>

          </h1>

          <div className="esc-directivo-line">

            <span></span>

            <div className="esc-directivo-dot"></div>

            <span></span>

          </div>

        </div>

        {/* Director */}

        <div className="esc-directivo-director">

          <div className="esc-directivo-card esc-directivo-main">

            <div className="esc-directivo-number">

              01

            </div>

            <img
              src={equipo[0].imagen}
              alt={equipo[0].nombre}
              onDoubleClick={() =>
                setImagenGrande(equipo[0].imagen)
              }
            />

            <div className="esc-directivo-name">

              <h3>{equipo[0].nombre}</h3>

            </div>

            <div className="esc-directivo-role">

              <div className="esc-directivo-divider"></div>

              <p>{equipo[0].cargo}</p>

            </div>

          </div>

        </div>

        {/* Línea Horizontal */}

        <div className="esc-directivo-horizontal"></div>

        {/* Equipo */}

        <div className="esc-directivo-grid">

          {equipo.slice(1).map((miembro, index) => (

            <div
              className="esc-directivo-item"
              key={index}
            >

              <div className="esc-directivo-vertical"></div>

              <div className="esc-directivo-card">

                <div className="esc-directivo-number">

                  {miembro.numero}

                </div>

                <img
                  src={miembro.imagen}
                  alt={miembro.nombre}
                  onDoubleClick={() =>
                    setImagenGrande(miembro.imagen)
                  }
                />

                <div className="esc-directivo-name">

                  <h3>{miembro.nombre}</h3>

                </div>

                <div className="esc-directivo-role">

                  <div className="esc-directivo-divider"></div>

                  <p>{miembro.cargo}</p>

                </div>

              </div>

            </div>

          ))}

                  </div>

        {/* Modal Imagen Grande */}

        {imagenGrande && (

          <div
            className="esc-directivo-modal"
            onClick={() => setImagenGrande(null)}
          >

            <img
              src={imagenGrande}
              alt="Imagen ampliada"
            />

          </div>

        )}

      </div>

    </section>

  );

}

export default QuienesSomos;